import { createClient } from '@/api/supabase'

/**
 * Запрос возврата платежа через edge function `tbank-refund-payment`.
 * Edge function проверяет роль (admin/dispatcher) по JWT, вызывает /v2/Cancel
 * на Т-Банке полной суммой и при успехе обновляет лид:
 *   status='cancelled', refunded_at=now().
 */
export interface RefundResult {
  ok: boolean
  refundedAt?: string
  reason?: string
  tbankErrorCode?: string
  tbankMessage?: string
  tbankDetails?: string
  detail?: string
  dbUpdateFailed?: boolean
}

export async function refundLeadPayment(leadId: string): Promise<RefundResult> {
  const supabase = createClient()
  const { data, error } = await supabase.functions.invoke('tbank-refund-payment', {
    body: { leadId },
  })
  if (error) {
    // supabase-js при HTTP != 2xx кладёт тело ответа в error.context. У
    // tbank-refund-payment это структурированный JSON (reason / tbankErrorCode
    // / tbankMessage / tbankDetails) — достаём его, иначе в UI попадёт сырое
    // «Edge Function returned a non-2xx status code».
    const ctx = (error as { context?: Response }).context
    if (ctx && typeof ctx.json === 'function') {
      try {
        return (await ctx.json()) as RefundResult
      } catch {
        // fallthrough
      }
    }
    return { ok: false, reason: 'invoke_failed', detail: error.message }
  }
  return (data ?? { ok: false, reason: 'no_response' }) as RefundResult
}
